import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-26b19fba"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "image-gallery-modal" }
const _hoisted_2 = {
  key: 0,
  class: "error"
}
const _hoisted_3 = { class: "upload" }
const _hoisted_4 = { class: "btn btn-primary file-button" }
const _hoisted_5 = ["onDrop"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "gallery-hint" }, "Or pick a FamilySearch memory:", -1))
const _hoisted_7 = {
  key: 0,
  class: "gallery"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 2,
  class: "empty"
}
const _hoisted_11 = {
  key: 3,
  class: "empty"
}

import { ref } from 'vue'
import Modal from '@/util/Modal.vue'
import { SourceImage } from './FamilySearchGameSource'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageGalleryModal',
  props: {
    images: {},
    loading: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { expose: __expose, emit }) {

const props = __props;





const errorRef = ref('')
const shownRef = ref(false)

const modalRef = ref<InstanceType<typeof Modal>>()

function open() {
  errorRef.value = ''
  modalRef.value?.open()
}

function close() {
  modalRef.value?.close()
}

// Cleared when the modal hides so a stale error doesn't linger and the tiles unmount.
function onHidden() {
  shownRef.value = false
  errorRef.value = ''
}

function onSource(source: SourceImage) {
  emit('select', { source })
}

function onFileChange(event: Event) {
  const input = event.target as HTMLInputElement
  const file = input.files?.[0]
  if (file) {
    emit('select', { file })
  }
  input.value = ''
}

function onDrop(event: DragEvent) {
  const file = event.dataTransfer?.files?.[0]
  if (file && file.type.startsWith('image/')) {
    emit('select', { file })
  }
}

// Lets the parent surface an upload failure (e.g. a CORS-blocked FS fetch) inside the modal.
function showError(message: string) {
  errorRef.value = message
}

__expose({ open, close, showError })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    large: "",
    "hide-actions": "",
    onShown: _cache[1] || (_cache[1] = ($event: any) => (shownRef.value = true)),
    onHidden: onHidden
  }, {
    title: _withCtx(() => [
      _createTextVNode("Add an image")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (errorRef.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(errorRef.value), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createTextVNode(" Choose file "),
            _createElementVNode("input", {
              type: "file",
              accept: "image/*",
              onChange: onFileChange
            }, null, 32)
          ]),
          _createElementVNode("div", {
            class: "drop-zone",
            onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
            onDrop: _withModifiers(onDrop, ["prevent"])
          }, " Drop an image file here ", 40, _hoisted_5)
        ]),
        (props.images.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6,
              (shownRef.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.images, (image) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: image.originalUrl,
                        type: "button",
                        class: "tile",
                        onClick: ($event: any) => (onSource(image))
                      }, [
                        _createElementVNode("img", {
                          src: image.displayUrl,
                          alt: "",
                          draggable: "false",
                          loading: "lazy"
                        }, null, 8, _hoisted_9)
                      ], 8, _hoisted_8))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (props.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Loading FamilySearch memories…"))
            : (_openBlock(), _createElementBlock("p", _hoisted_11, "No FamilySearch memories for this card.")),
        _createElementVNode("div", { class: "actions" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-outline-primary",
            onClick: close
          }, "Close")
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})